import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import ServicePageLayout from '../layouts/ServicePageLayout';
import TestimonialCard from '../components/TestimonialCard';
import DetailedProcess from '../components/DetailedProcess';
import PlaceholderImage from '../components/PlaceholderImage';
import AppDevHero from '../components/AppDevHero/AppDevHero';
import ContactBanner from '../components/ContactBanner/ContactBanner';
import { useTranslation } from 'react-i18next';

const AppDevPage = () => {
  const { t } = useTranslation();

  const title = t('appDevPage.title');
  const subtitle = t('appDevPage.subtitle');

  const features = [
    { key: 'mobile' },
    { key: 'web' },
    { key: 'api' },
    { key: 'database' },
  ].map(feature => ({
    title: t(`appDevPage.features.${feature.key}.title`),
    description: t(`appDevPage.features.${feature.key}.description`),
  }));

  const processSteps = [
    { key: 'analysis' },
    { key: 'design' },
    { key: 'development' },
    { key: 'deployment' },
  ].map(step => ({
    title: t(`appDevPage.process.steps.${step.key}.title`),
    description: t(`appDevPage.process.steps.${step.key}.description`),
  }));

  return (
    <>
      <AppDevHero title={title} subtitle={subtitle} />
      <ServicePageLayout
        title={title}
        subtitle={subtitle}
        features={features}
        hideHero={true}
      >
        <div className="space-y-20">
          <section className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-10 text-center">{t('appDevPage.process.title')}</h2>
            <DetailedProcess steps={processSteps} />
          </section>
        </div>

        <ContactBanner 
            title={t('appDevPage.contactBanner.title')}
            description={t('appDevPage.contactBanner.description')}
            buttonText={t('appDevPage.contactBanner.buttonText')}
            buttonLink="/start-your-project"
        />
      </ServicePageLayout>
    </>
  );
};

export default AppDevPage; 